import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

class RichTextEditor extends React.Component {
  static toolbarModules = {
    toolbar: [
      [{ size: ["small", false, "large", "huge"] }],
      ["bold", "italic", "underline", "strike"],
      [{ align: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["clean"],
    ],
  };

  static formats = [
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "align",
    "list",
    "bullet",
  ];

  constructor(props) {
    super(props);
    this.quillComponentRef = React.createRef();
  }

  // ✅ Parent can call: this.richTextRef.current.getEditor()
  getEditor = () => {
    return this.quillComponentRef.current?.getEditor?.() || null;
  };

  render() {
    const { value, onChange, readOnly, placeholder, className } = this.props;
    const modules = readOnly ? { toolbar: false } : RichTextEditor.toolbarModules;

    return (
      <ReactQuill
        ref={this.quillComponentRef}
        theme="snow"
        value={value || ""}
        onChange={onChange}
        readOnly={!!readOnly}
        modules={modules}
        formats={RichTextEditor.formats}
        placeholder={placeholder || "Write your note..."}
        className={className}
      />
    );
  }
}

export default RichTextEditor;
